import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AudioState } from 'src/app/shared/constants';

@Component({
    selector: 'app-audio-player',
    templateUrl: './audio-player.component.html',
    styleUrl: './audio-player.component.scss',
    standalone: false
})
export class AudioPlayerComponent implements OnInit {

  @Input() audioSrc: string | undefined;
  @Input() recordingArray: string[]=[];
  @Input() stateType: number | undefined;
  @Input() currentRecording:number=0;
  @Output() playerEvents = new EventEmitter<number>();
  isVisible: boolean = false;
  constructor() { }

  ngOnInit(): void { }

  ngOnChanges() {
    switch (this.stateType) {
      case AudioState.Start:
        this.isVisible = true;
        break;
      case AudioState.Play:
        this.play();
        break;
      case AudioState.Pause:
        break;
      case AudioState.End:
        this.stop();
        this.isVisible = false;
        break;
    }
  }
  play() {
    const player = document.getElementById('audio-player') as HTMLAudioElement;
    if (player) {
      player.play();
    }
  }

  pause() { }

  stop() {
    const player = document.getElementById('audio-player') as HTMLAudioElement;
    if (player) {
      player.pause();
      player.currentTime = 0;
    }
  }
  playNext(){
    const player = document.getElementById('audio-player') as HTMLAudioElement;
     if (player) {
      if(this.recordingArray.length===this.currentRecording+1){
        return
      }
      this.audioSrc=this.recordingArray[this.currentRecording+1];
      this.currentRecording=this.currentRecording+1;
      player.load();
      player.play();
    }
  }
  playPrevious(){
    const player = document.getElementById('audio-player') as HTMLAudioElement;
     if (player) {
       if(this.currentRecording===0){
        return
      }
      this.audioSrc=this.recordingArray[this.currentRecording-1];
      this.currentRecording=this.currentRecording-1;
      player.load();
      player.play();
    }
  }
  emitEvents() {
  }

  closeDialog() {
    this.stop();
    this.playerEvents.emit(AudioState.End);
    this.isVisible = false;
  }

  onPlayAudio(event: any) {
    this.playerEvents.emit(AudioState.Play);
  }
  onPauseAudio(event: any) {
    this.playerEvents.emit(AudioState.Pause);
  }
  onEndAudio(event: any) {
    this.playerEvents.emit(AudioState.End);
  }
  onLoad(event: any) {
    this.playerEvents.emit(AudioState.Start);
  }
}